module.exports = __webpack_public_path__ + "static/img/7.f6dc015.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/2/3/eng/7.png
// module id = 1JDu
// module chunks = 0